import { Home, Mail, Target, Users, Building2, MoreHorizontal, FileText, UserPlus, CheckSquare, Settings } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';

const primaryNavItems = [
  { path: '/', icon: Home, label: 'Home' },
  { path: '/inbox', icon: Mail, label: 'Inbox' },
  { path: '/opportunities', icon: Target, label: 'Deals' },
  { path: '/contacts', icon: Users, label: 'Contacts' },
];

const moreNavItems = [
  { path: '/companies', icon: Building2, label: 'Companies' },
  { path: '/account-planning', icon: FileText, label: 'Planning' },
  { path: '/leads', icon: UserPlus, label: 'Leads' },
  { path: '/tasks', icon: CheckSquare, label: 'Tasks' },
  { path: '/settings', icon: Settings, label: 'Settings' },
];

export function MobileBottomNav() {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-background border-t md:hidden safe-area-inset-bottom">
      <div className="flex items-center justify-around h-16">
        {primaryNavItems.map(({ path, icon: Icon, label }) => (
          <Link
            key={path}
            to={path}
            className={cn(
              "flex flex-col items-center justify-center flex-1 h-full gap-1",
              "transition-colors duration-200",
              isActive(path)
                ? "text-primary"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            <Icon className="h-5 w-5" />
            <span className="text-xs font-medium">{label}</span>
          </Link>
        ))}
        
        <Sheet>
          <SheetTrigger className="flex flex-col items-center justify-center flex-1 h-full gap-1 text-muted-foreground hover:text-foreground">
            <MoreHorizontal className="h-5 w-5" />
            <span className="text-xs font-medium">More</span>
          </SheetTrigger>
          <SheetContent side="bottom" className="h-[80vh]">
            <SheetHeader>
              <SheetTitle>More Options</SheetTitle>
            </SheetHeader>
            <div className="grid grid-cols-3 gap-4 mt-6">
              {moreNavItems.map(({ path, icon: Icon, label }) => (
                <Link
                  key={path}
                  to={path}
                  className={cn(
                    "flex flex-col items-center gap-3 p-4 rounded-lg",
                    "transition-colors duration-200",
                    isActive(path)
                      ? "bg-primary/10 text-primary"
                      : "hover:bg-accent"
                  )}
                >
                  <Icon className="h-6 w-6" />
                  <span className="text-sm font-medium text-center">{label}</span>
                </Link>
              ))}
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  );
}
